const calc_default = document.querySelectorAll('.calc-default');
let dateCookie = new Date(new Date().getTime() + 2592000000);
const defaultAmount = typeof calcDefaultSum !== 'undefined' ?  +calcDefaultSum : 3000;
const loanTerm = typeof calcLoanTerm !== 'undefined' ? +calcLoanTerm : 15;

calc_default.forEach(e => {
    e.addEventListener('click', () => {
        const option_other = document.querySelector('option[data-type="other"]');
        let id_other = '';

        if (!!option_other)
            id_other = option_other.value;

        document.cookie = "loan_sum=" + defaultAmount + "; path=/; expires=" + dateCookie.toUTCString() + "secure; SameSite=Strict";
        document.cookie = "loan_term=" + loanTerm + "; path=/; expires=" + dateCookie.toUTCString() + "  secure; SameSite=Strict";
        document.cookie = `loan_purpose=${id_other}; path=/; expires=` + dateCookie.toUTCString(); + ` secure; SameSite=Strict`;
    });
});
